<template>
<div class="word" v-if="word" :class="'word-'+$store.state.endRound">
	<input
		v-for="index in word.length"
		v-model="letters[index]"
		maxlength="1"
		autocomplete="mondadori"
		:ref="'letter-'+index" 
		class="letter"
		inputmode="none"
		browser-autocomplete="new-password"
		:class="{
			['color-'+color]: true,
			['letter-'+index]: true,
			'is-error': isError,
			'locked': structure[index-1] && structure[index-1].type == 'hint'
		}"
		:key="index"
		@focus="() => focus(index)"
		@change="() => checkError()"
		@keydown="(event) => move(event,index)"
		@click="() => select(index)"
		:disabled="false"
		:draggable="false"
	/>
	</div>
</template>

<script>

export default {
	props: ['word','hint','letter','color'],
	data() {
		return {
			letters: [],
			structure: [],
			isError: false,
		}
	},
	watch: {
		'$store.state.endRound'() {

			if(this.$store.state.currentKey && this.$refs['letter-'+this.$store.state.currentKey] && this.$refs['letter-'+this.$store.state.currentKey][0]) {
				this.$refs['letter-'+this.$store.state.currentKey][0].blur();
				
				let index = 1;
				let zoomInLettersTimer = setInterval(() => {
					if(index <= this.word.length && this.$refs['letter-'+index][0] && this.$refs['letter-'+index][0].classList) {
						this.$refs['letter-'+index][0].classList += ' flash';
						index++;
					}
					else {
						clearInterval(zoomInLettersTimer);
					}
				},300);
			}
		},
		letters() {

			let index = this.$store.state.currentKey+1;
			this.$emit('update',this.letters);
			if(this.$store.state.currentKey == this.word.length) {
				this.$refs['letter-'+this.$store.state.currentKey][0].blur();
			}
			else {
				for(let id = index; id <= this.word.length; id++) {
					if( this.$refs['letter-'+id] && !this.$refs['letter-'+id][0].classList.contains('locked')) {
						this.$refs['letter-'+id][0].focus();
						this.$refs['letter-'+id][0].select();
						return false;
					}
				}
			}
		},
		letter() {
			let letters = this.letters;
			letters[this.letter.index] = this.letter.letter;

			this.letters = false;
			this.letters = letters;
			this.checkError();

		},
		hint(value) {
			if(typeof value !== 'boolean') {
				this.playAudio('hint');
				
				this.structure[value.offset] = {
					type: 'hint',
					letter: value
				};
				let letters = this.letters;
				for(let single in this.structure) {
					if(this.structure[single]) {
						this.structure[single]['locked'] = true;
						letters[this.structure[single].letter.offset + 1] = this.structure[single].letter.letter;
					}
				}

				this.letters = false;
				this.letters = letters;
			
			}
		}
	},
	methods: {
		select(index) {
			this.checkError();
			if(this.$refs['letter-'+(index)]) {
				this.$refs['letter-'+(index)][0].select();
			}
		},
		checkError() {
			let writed = '';
			for(let letter in this.$refs) {
				if(this.$refs[letter][0].value) {
					writed += this.$refs[letter][0].value;
				}
			}
			if(writed.length == this.word.length && writed != this.word) {
				this.isError = true;
				this.playAudio('error');
				setTimeout(() => {
					this.isError = false;
					let hintsIn = [];

					for(let index in this.structure) {
						hintsIn.push(parseInt(index)+1);
					}

					for(let letter in this.letters) {
						if(!hintsIn.includes(parseInt(letter))) {
							this.letters[letter] = '';
						}
					}
				},750)
			}
			else {
				this.isError = false;
			}
		},
		focus(index) {
			this.checkError();
			//this.$refs['letter-'+(index)][0].focus();
			setTimeout(() => {
				this.$refs['letter-'+(index)][0].select();
			},1)
			this.updateProperty({
				property: "currentKey",
				value: index
			});
		},
		move(event) {
			this.checkError();
			if(event.keyCode === 8) {
				for(let id = (this.$store.state.currentKey-1); id > 0; id--) {
					if( this.$refs['letter-'+id] && this.$refs['letter-'+id][0] && !this.$refs['letter-'+id][0].classList.contains('locked')) {
						this.focus(id);
						return false;
					}
				}
			}

			if(event.keyCode === 37) {
				for(let id = (this.$store.state.currentKey-1); id > 0; id--) {
					if( this.$refs['letter-'+id] && this.$refs['letter-'+id][0] && !this.$refs['letter-'+id][0].classList.contains('locked')) {
						this.focus(id);
						return false;
					}
				}
			}
			else if(event.keyCode === 39) {
				for(let id = (this.$store.state.currentKey+1); id <= this.word.length; id++) {
					if( this.$refs['letter-'+id] && this.$refs['letter-'+id][0] && !this.$refs['letter-'+id][0].classList.contains('locked')) {
						this.focus(id);
						return false;
					}
				}
			}
			else {
				this.playAudio('inputType'); 
			}

		}, 
		up(event, index) {
			this.checkError();
			if(event.inputType == 'insertText') {
				let result = '';
				for(let letter in this.letters) {
					result += this.letters[letter]? this.letters[letter] : '';
				}
				
				let nextEl = this.$refs['letter-'+(index+1)];
				if(nextEl) {
					nextEl[0].focus();
				}
				this.$emit('return', result);
			}
			else {
				let prevEl = this.$refs['letter-'+(index-1)];
				if(prevEl) {
					prevEl[0].focus();
				}
			}
		}
	}
}
</script>
<style lang="scss" scoped>
	.word {
		display: flex;
		justify-content: center;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.letter {
		cursor: pointer;
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

		&.color-orange {
			color: $mondadori-orange;
			&.locked,
			&:disabled {
				background: $mondadori-light-orange !important;
			}
		}

		&.color-pink {
			color: $mondadori-pink;
			&.locked,
			&:disabled {
				background: $mondadori-light-pink !important;
			}
		}

		margin: 0 px(5);
		border-radius: px(8);
		text-align: center;
		border-bottom: px(4) solid #f1f1f1;
		box-shadow: px(-2) px(2) px(4) px(3) rgba(0,0,0,0.1);
		background: #fff;
		width: px(100);
		height: px(100);
		font-size: px(50);
		text-transform: uppercase;
		outline: 0;
		transition: transform 0.3s;
		@include breakpoint(s) {
			width: px(55);
			height: px(70);
			font-size: px(40);
		}
		&:first-child {
			margin-left: 0;
		}
		
		&:last-child {
			margin-right: 0;
		}

		&:focus {
			transform: scale(1.5);
		}

		&::selection {
			color: #000;
		}
		&.locked,
		&:disabled {
			pointer-events: none !important;
			color: #fff !important;
			animation: shake 0.5s !important;
			animation-iteration-count: infinite !important;
		}
		
		&.locked.flash {
			animation: flash 0.5s !important;
			animation-iteration-count: linear !important;
		}

		&.is-error:not(&.locked, &.disabled) {
			pointer-events: none !important;
			background: #ff5454;
			color: #fff !important;
		}

	}

	.word {
		&.word-lost,
		&.word-win {
			.letter {
				animation: none !important;
				&.flash {
					animation: flash 0.5s !important;
					animation-iteration-count: linear !important;
				}
			}
			
		}
	}

	@keyframes flash {
		0% { transform: scale(1)}
		50% {transform: scale(2)}
		100% { transform: scale(1)}
	}

	@keyframes shake {
		0% { transform: translate(1px, 1px) rotate(0deg); }
		10% { transform: translate(-1px, -2px) rotate(-1deg); }
		20% { transform: translate(-3px, 0px) rotate(1deg); }
		30% { transform: translate(3px, 2px) rotate(0deg); }
		40% { transform: translate(1px, -1px) rotate(1deg); }
		50% { transform: translate(-1px, 2px) rotate(-1deg); }
		60% { transform: translate(-3px, 1px) rotate(0deg); }
		70% { transform: translate(3px, 1px) rotate(-1deg); }
		80% { transform: translate(-1px, -1px) rotate(1deg); }
		90% { transform: translate(1px, 2px) rotate(0deg); }
		100% { transform: translate(1px, -2px) rotate(-1deg); }
	}
</style>
